import { createContext, type Context } from 'react';

import type { LoggedInUser, UserContextValue } from './types';

const DEFAULT_IDENTITY: LoggedInUser = {
	id: '',
	picture: '',
	accountId: '',
	name: '',
	nickname: '',
	email: '',
	staffId: '',
	isAtlassianEmployee: false,
};

/**
 * Microsite-local UserContext stub.
 *
 * The dtac graph explorer originally relied on a full UserProvider that managed
 * authentication, profile fetching, and relay queries. The microsite renders
 * the explorer in a public/landing context where we do not have (or need) a
 * full auth flow, so we expose a minimal default value here.
 *
 * Consumers of `useAtlassianUserContext` will read this default identity when
 * no UserProvider wraps the tree.
 */
export const UserContext: Context<UserContextValue> = createContext<UserContextValue>({
	identity: DEFAULT_IDENTITY,
	loading: false,
	error: false,
	handleAuthFailure: async () => undefined,
});
